const ADD_CONFIRM = 'ADD_CONFIRM';
const ADD_MESSAGE = 'ADD_MESSAGE';
const CLOSE_CONFIRM = 'CLOSE_CONFIRM';
const CLOSE_MESSAGE = 'CLOSE_MESSAGE';

export { ADD_CONFIRM, ADD_MESSAGE, CLOSE_CONFIRM, CLOSE_MESSAGE };
